import { SimplePageModule } from "./simple_page";
import { getTopLevelNavLinks } from "~/modules/menu_data";
export class home extends SimplePageModule {
    getModuleName() {
        return "home";
    }
    getPageTitle() {
        return "Home";
    }
    getNavLinks() {
        return getTopLevelNavLinks();
    }
}
